export default __webpack_public_path__ + "static/media/wed-blue.0ee3c013.png";